const TokenService = {
  setToken: (token: string) => {
    sessionStorage.setItem("cex-token", token);
  },
  getToken: () => {
    return sessionStorage.getItem("cex-token");
  },
  clearToken: () => {
    sessionStorage.removeItem("cex-token");
  },
  clearSession: () => {
    sessionStorage.clear();
  },
};

export default TokenService;
